import { useTheme } from '@mui/material';
import { SlideoutDrawer } from '#components/SlideoutDrawer/index.tsx';
import { Ancestor } from '#enums/ancestors.ts';
import { Collection } from './Collection.tsx';
import { type PartData } from './types.ts';

export type EpisodesDrawerProps = {
  items: PartData[];
  name: string | undefined;
  onPartClick: (part: string | number) => void;
  open: boolean;
  selectedPartId: string | number;
  setOpen: (value: boolean) => void;
};

export const CollectionDrawer = ({ items, name, onPartClick, open, selectedPartId, setOpen }: EpisodesDrawerProps) => {
  const theme = useTheme();

  return (
    <SlideoutDrawer
      ancestor={Ancestor.Playlist}
      anchor="left"
      headerIcon="close"
      open={open}
      setOpen={setOpen}
      sx={{
        '.MuiDrawer-paper': {
          [theme.breakpoints.up('md')]: {
            width: '75%',
          },
          [theme.breakpoints.up('lg')]: {
            width: '50%',
          },
          [theme.breakpoints.up('xl')]: {
            width: '50%',
          },
        },
        'z-index': 1300,
      }}
      title={name}
    >
      <Collection onPartClick={onPartClick} parts={items} selectedPartId={selectedPartId} />
    </SlideoutDrawer>
  );
};
